import { SVGProps } from 'react';

const BackSpaceIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2301_857)">
        <mask
          id="mask0_2301_857"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="48"
        >
          <path d="M48 0H0V48H48V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2301_857)">
          <path
            d="M46.0001 36.4997C46.0001 38.7088 44.2092 40.4997 42.0001 40.4997H15.1411C13.8037 40.4997 12.5548 39.8313 11.8129 38.7185L2.00049 23.9999L11.8129 9.2812C12.5548 8.16841 13.8037 7.5 15.1411 7.5H42.0001C44.2092 7.5 46.0001 9.29086 46.0001 11.5V36.4997Z"
            stroke="#3D3F42"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5 16.7617L35.9736 31.2353"
            stroke="#3D3F42"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.9736 16.7617L21.5 31.2353"
            stroke="#3D3F42"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2301_857">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BackSpaceIcon;
